<template>
  <v-container>
    <v-card>
      <v-card-title>Notes</v-card-title>
      <v-card-text>
        <v-alert
          type="info"
          border="top"
          elevation="2"
          colored-border
        >
          {{ notes }}
        </v-alert>
        
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    name: 'SoftwareNotes',
    props: {
      notes: String,
    },
    data () {
      return {
        
      }
    }
  }
</script>